
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    // Handle the OAuth callback
    const handleAuthCallback = async () => {
      try {
        // Get the session from the URL hash
        const { error } = await supabase.auth.getSession();
        
        if (error) throw error;
        
        toast({
          title: "Successfully authenticated",
          description: "You have successfully signed in with Google."
        });
        
        // Redirect to the home page
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Error during authentication:", error);
        toast({
          variant: "destructive",
          title: "Authentication failed",
          description: "There was a problem completing the authentication. Please try again."
        });
        navigate("/", { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-300 via-pink-200 to-blue-300">
      <div className="bg-white/80 backdrop-blur-md p-8 rounded-lg shadow-xl text-center">
        <h1 className="text-2xl font-bold mb-4">Completing authentication...</h1>
        <p className="text-gray-600">Please wait while we finish setting up your account.</p>
        <div className="mt-6 flex justify-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
        </div>
      </div>
    </div>
  );
}
